import image1 from './logo.jpg'
import image2 from './background.jpg'
import videos1 from "./Video.mp4"
import videos2 from "./Video2.mp4"
import videos3 from "./Video3.mp4"
import videos4 from "./Video4.mp4"
import videos5 from "./Video5.mp4"
import videos6 from "./Video6.mp4"
import videos7 from "./Diamond Push Up.mp4"
import videos8 from "./Bench Dips_ Strength (Chest_Triceps).mp4"
import videos9 from "./✅ HOW to do CHIN UPS.mp4"
import videos10 from "./How to do a bodyweight squat _ Bupa Health.mp4"
import videos11 from "./Forward Lunges Exercise Demonstration.mp4"
import videos12 from "./videoplayback.mp4"
import videos13 from "./pushups.mp4"
import videos14 from "./How to do an Incline Push-Up.mp4"
import videos15 from "./How to do a Decline Push-Up.mp4"
import videos16 from "./How to do a Pike Push-Up.mp4"
import videos17 from "./Bodyweight Lateral Raise.mp4"
import videos18 from "./Bodyweight Bent Over Reverse Fly.mp4"
import videos19 from "./Video7.mp4"
import videos20 from "./Video8.mp4"
import videos21 from "./Video9.mp4"
import videos22 from "./Video10.mp4"
import videos23 from "./Video11.mp4"
import videos24 from "./Video12.mp4"
import videos25 from "./Video13.mp4"
import videos26 from "./Video14.mp4"
import videos27 from "./Video15.mp4"
import videos28 from "./Video16.mp4"
import videos29 from "./Video17.mp4"
import videos30 from "./Video18.mp4"
import videos31 from "./Video19.mp4"
import videos32 from "./Video20.mp4"
import videos33 from "./Video21.mp4"
import videos34 from "./Video22.mp4"
import videos35 from "./Video23.mp4"
import videos36 from "./Video24.mp4"
const Imgs = {
    logo : image1,
    back : image2,
    video : videos1,
    video1 : videos2,
    video2 : videos3,
    video3 : videos4,
    video4 : videos5,
    video5 : videos6,
    video6 : videos7,
    video7 : videos8,
    video8 : videos9,
    video9 : videos10,
    video10 : videos11,
    video11 : videos12,
    video12 : videos13,
    video13 : videos14,
    video14 : videos15,
    video15 : videos16,
    video16 : videos17,
    video17 : videos18,
    video18 : videos19,
    video19 : videos20,
    video20 : videos21,
    video21 : videos22,
    video22 : videos23,
    video23 : videos24,
    video24 : videos25,
    video25 : videos26,
    video26 : videos27,
    video27 : videos28,
    video28 : videos29,
    video29 : videos30,
    video30 : videos31,
    video31 : videos32,
    video32 : videos33,
    video33 : videos34,
    video34 : videos35,
    video35 : videos36
}
export default Imgs;